interface IData {
  firstName: string;
  lastName: string;
  position: string;
}

export const prepareFullNameWithPosition = (data: IData): string | null => {
  const fullName = `${data.firstName} ${data.lastName}`.trim();

  if (!fullName) {
    return null;
  }

  return [fullName, data.position].filter(Boolean).join(', ');
};
